module.exports = __webpack_public_path__ + "img/Pathfinder.251e4e91.png";